/* eslint-disable react/jsx-no-target-blank */
import React, { Component } from "react";
import * as cms from "../../shared/repos/cms/cms";
import cmsKeys from "../../shared/constants/cms";

import styles from "./Contact.module.css";

import CmsInlineEdit from "../../components/Cms/CmsInlineEdit";
import Input from "../../components/Input/Input";
import Button from "../../components/Button/Button";
import { handleFormInput } from "../../shared/utilities/validations";
import * as contactRepo from "../../shared/repos/graphql/contact";

const caretRightImage = require("./imgs/caret-right.png");
const caretLeftImage = require("./imgs/caret-left.png");
const submitImage = require("./imgs/submit.png");


class ShareFeedback extends Component {
  constructor(props) {
    super(props);
    this.state = {
      content: [],
      step: 1,
      selectedTopic: null,
      selectedOption: null,
      loading: false,
      apiMessage: null,
      // Additional state for renderInput/renderTextArea compatibility
      fullName: "",
      email: "",
      comment: "",
      formValid: false
    };
  }

  componentDidMount() {
    cms.getContent([cmsKeys.share_feedback_topic], this);
  }

  toggleQuestion = id => {
    this.setState(prev => ({
      expandedQuestionId: prev.expandedQuestionId === id ? null : id
    }));
  };

  checkFormValidity = () => {
    const { fullName, email, comment } = this.state;
    
    const isNameValid = fullName?.trim().length > 0;
    const isEmailValid = email?.trim().length > 0 && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    const isCommentValid = comment?.trim().length > 0;
    
    const formValid = isNameValid && isEmailValid && isCommentValid;
    this.setState({ formValid });
  };

  renderInput = (
    component,
    label,
    state,
    isTextArea = false,
    validationType = "string",
    inputMask = ""
  ) => {
    const text = component.state[state];

    return (
      <Input
        isTextArea={isTextArea}
        theme="dark"
        customContainerStyles={styles.inputWrapper}
        handleInput={e => {
          handleFormInput(e, component, state, validationType);
          component.checkFormValidity();
        }}
        placeholder=" "
        value={text}
        label={label}
        inputMask={inputMask}
      />
    );
  };

  renderTextArea = (component, label = "Description...") => {
    const { comment } = component.state;
    return (
      <div>
        <Input
          isTextArea
          theme="dark"
          customContainerStyles={styles.textareaWrapper}
          handleInput={e => {
            if (e.target.value.length <= 1000) {
              handleFormInput(e, component, "comment");
            }
            component.checkFormValidity();
          }}
          placeholder=" "
          value={comment}
          label={label}
        />
      </div>
    );
  };

  render() {
    const {
      content,
      step = 1,
      selectedTopic = null,
      selectedOption = null,
      loading = false,
      apiMessage = null,
      formValid = false
    } = this.state;

    // STEP 1 → Topics list
    if (step === 1) {
      return (
        <div className="flex flex-col gap-4 w-full min-w-[375px] lg:w-[1000px] mx-auto">
          <h2 className="text-[28px] leading-7 tracking-[-0.2px] font-black font-congenialBlack dark:text-light text-dark mb-6">Choose a topic</h2>
          {content.map(topic => (
            <CmsInlineEdit cmsNode={topic} type="list" showContent showChilds>
              <div
                key={topic.cmsKeyId}
                onClick={() => {
                this.setState({
                  step: 2,
                  selectedTopic: topic,
                  selectedOption: null,
                  apiMessage: null
                });
              }}
                onKeyDown={e => {
                if (e.key === "Enter" || e.key === " ") {
                  this.setState({
                    step: 2,
                    selectedTopic: topic,
                    selectedOption: null,
                    apiMessage: null
                  });
                }
              }}
                role="button"
                tabIndex={0}
                className="w-full font-bold text-[16px] leading-[20px] tracking-normal font-montserratBold text-dark dark:text-white border border-[#E6DFE8] rounded-lg px-6 py-4 cursor-pointer flex justify-between items-center group"
              >
             
                {topic.value}
             
                <img
                  src={caretRightImage}
                  alt=""
                  className="w-4 h-4 group-hover:translate-x-1 transition-transform"
                />
              </div>
            </CmsInlineEdit>
          ))}
        </div>
      );
    }

    // STEP 2 → Options for selected topic
    if (step === 2 && selectedTopic) {
      return (
        <div className="flex flex-col gap-4 w-full min-w-[375px] lg:w-[1000px] mx-auto">
          <button
            type="button"
            onClick={() => this.setState({ step: 1, selectedTopic: null })}
            className="text-lg leading-[22px] tracking-[-0.1px] font-montserratBold font-bold text-dark hover:underline mb-2 flex items-center gap-1 bg-transparent"
          >
            <img src={caretLeftImage} alt="" />
            <span>Back</span>
          </button>

          <h2 className="text-[28px] leading-7 tracking-[-0.2px] font-black font-congenialBlack dark:text-light text-dark mb-6">
            {selectedTopic.value}
          </h2>

          {selectedTopic.children
            .filter(child => child.key === "option")
            .map(option => (
              <div
                key={option.cmsKeyId}
                onClick={() => {
                  this.setState({
                    step: 3,
                    selectedOption: option,
                    fullName: "",
                    email: "",
                    comment: "",
                    apiMessage: null,
                    formValid: false
                  });
                }}
                onKeyDown={e => {
                if (e.key === "Enter" || e.key === " ") {
                  this.setState({
                    step: 3,
                    selectedOption: option,
                    fullName: "",
                    email: "",
                    comment: "",
                    apiMessage: null,
                    formValid: false
                  });
                }
              }}
                role="button"
                tabIndex={0}
                className="w-full font-bold text-[16px] leading-[20px] tracking-normal font-montserratBold text-dark dark:text-light bg-gray-100 border border-gray-200 rounded-lg px-6 py-4 cursor-pointer hover:bg-gray-200 transition-all duration-200 flex justify-between items-center group"
              >
                <CmsInlineEdit
                  cmsNode={option}
                  className=""
                >
                  {option.value}
                </CmsInlineEdit>
                <img
                  src={caretRightImage}
                  alt=""
                  className="w-4 h-4 group-hover:translate-x-1 transition-transform"
                />
              </div>
            ))}
        </div>
      );
    }

    // STEP 3 → Feedback form
    if (step === 3 && selectedOption && selectedTopic) {
      const validate = () => {
        const { fullName, email, comment } = this.state;
        const newErrors = {};
        if (!fullName?.trim()) newErrors.name = "Name is required";
        if (!email?.trim()) newErrors.email = "Email is required";
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))
          newErrors.email = "Invalid email format";
        if (!comment?.trim())
          newErrors.message = "Feedback message is required";
        return newErrors;
      };

      const submitFeedback = async e => {
        e.preventDefault();

        const newErrors = validate();
        if (Object.keys(newErrors).length > 0) {
          // Handle validation errors - could show error messages here
          return;
        }

        this.setState({ loading: true, apiMessage: null });

        const recipientEmail =selectedTopic.children.filter(child => child.key === "email").map(item => item.value)

        try {
          // API call to submit feedback
          const { fullName, email, comment } = this.state;
          const subject = `${selectedTopic.value} - ${ selectedOption.value}`;
          contactRepo
            .submitContactForm({
              formType: "ShareFeedback",
              formKey: "",
              orderNumber: "",
              fullName,
              email,
              phone: "",
              store: "",
              comment,
              organizationName: "",
              eventLocation: "",
              eventDate: "",
              eventType: "",
              proposedLocation: "",
              productName: "",
              productCost: "",
              subject,
              giftcardNumber: "",
              giftcardAmount: "",
              recipientEmail: recipientEmail[0],
              rewardAccountEmail: "",
              file: null,
              topic: selectedTopic.value,
              option: selectedOption.value,
            })
            .then(() => {
              this.setState({
                apiMessage: {
                  type: "success",
                  text: "Feedback submitted successfully!"
                },
                loading: false,
                fullName: "",
                email: "",
                comment: "",
                formValid: false
              });
            })
            .catch(error => {
              const { message } = error.graphQLErrors[0];
              this.setState({
                apiMessage: {
                  type: "error",
                  text: message || "Submission failed"
                },
                loading: false
              });
            });
        } catch (err) {
          this.setState({
            apiMessage: {
              type: "error",
              text: err.message || "Submission failed"
            },
            loading: false
          });
        }
      };

      return (
        <div className="flex flex-col gap-2 w-full lg:w-[1000px] mx-auto">
          <button
            type="button"
            onClick={() => {
              this.setState({
                step: 2,
                selectedOption: null,
                apiMessage: null
              });
            }}
            className="text-lg leading-[22px] tracking-[-0.1px] font-montserratBold font-bold text-dark hover:underline flex items-center gap-1 bg-transparent"
          >
            <img src={caretLeftImage} alt="" />
            <span>Back</span>
          </button>

          <h2 className="text-[28px] leading-7 tracking-[-0.2px] font-black font-congenialBlack dark:text-light text-dark mb-2">
            {selectedOption.value}
          </h2>

          <p className="font-montserratMedium text-[16px] leading-[20px] tracking-normal text-dark dark:text-light">
            We appreciate your input! Share your feedback and contact info
            below.
          </p>

          <form onSubmit={submitFeedback} className="flex flex-col gap-0">
            <div className="flex items-center justify-between gap-8">
              {this.renderInput(this, "Name*", "fullName", false, "string")}
            
              {this.renderInput(this, "Email*", "email", false, "email")}
            </div>

            <div>{this.renderTextArea(this, "Type your feedback here *")}</div>

            <Button
              handleSubmit={submitFeedback}
              label={
                loading ? (
                  "Submitting..."
                ) : (
                  <div className="flex items-center justify-center gap-2">
                    <img src={submitImage} alt="" />
                    Submit
                  </div>
                )
              }
              disabled={!formValid || loading}
              customContainerStyles={`${styles.submitButton} ${formValid ? '' : styles.disabledButton}`}
              theme="Light"
            />

            {apiMessage && (
              <div
                className={`p-4 rounded-lg text-center ${
                  apiMessage.type === "success"
                    ? "bg-green-100 text-green-800 border border-green-200"
                    : "bg-red-100 text-red-800 border border-red-200"
                }`}
              >
                {apiMessage.text}
              </div>
            )}
          </form>
        </div>
      );
    }

    return null;
  }
}

export default ShareFeedback;
